export default "__VITE_ASSET__D17bh073__"